/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Notification timing */
export enum NotificationTiming {
  Immediate,
  Delayed,
  Batched,
  Scheduled,
}

export type NotificationTimingArgs = NotificationTiming;

export function getNotificationTimingEncoder(): FixedSizeEncoder<NotificationTimingArgs> {
  return getEnumEncoder(NotificationTiming);
}

export function getNotificationTimingDecoder(): FixedSizeDecoder<NotificationTiming> {
  return getEnumDecoder(NotificationTiming);
}

export function getNotificationTimingCodec(): FixedSizeCodec<
  NotificationTimingArgs,
  NotificationTiming
> {
  return combineCodec(
    getNotificationTimingEncoder(),
    getNotificationTimingDecoder(),
  );
}
